import { styled } from 'styled-components';

export const GridContainer = styled.table`
  width: 1425px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
`;
